import { Link } from 'react-router-dom';
import { Option } from '@/types/dropdown.types';

interface DropdownItemProps {
  option: Option;
  className?: string;
  closeDropdown: () => void;
  hoverRoundedTop?: boolean;
  hoverRoundedBottom?: boolean;
}

function DropdownItem({ option, className, closeDropdown, hoverRoundedTop, hoverRoundedBottom }: DropdownItemProps) {
  const commonClasses = `px-4 py-2 hover:bg-gray-100 flex items-center cursor-pointer flex items-center gap-4 whitespace-nowrap ${hoverRoundedTop ? 'rounded-t-lg' : ''} ${hoverRoundedBottom ? 'rounded-b-lg' : ''} ${className || ''}`;

  const content = (
    <>
      {option.icon && <option.icon className='text-gray-600 w-4 h-4' />}
      <span>{option.label}</span>
    </>
  );

  return option.to ? (
    <Link data-cy='dropdown-link' to={option.to} className={commonClasses} onClick={closeDropdown}>
      {content}
    </Link>
  ) : (
    <button
      data-cy='dropdown-button'
      onClick={() => {
        option.onClick?.();
        closeDropdown();
      }}
      className={`w-full ${commonClasses}`}
    >
      {content}
    </button>
  );
}

export default DropdownItem;
